const PhilippinesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112152)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9996 0V20L5.85742 34.1422C9.47672 37.7614 14.4767 40 19.9996 40C31.0452 40 39.9996 31.0456 39.9996 20C39.9996 8.95437 19.9996 0 19.9996 0Z"
        fill="#D80027"
      />
      <path
        d="M19.9996 0C14.4767 0 9.47672 2.23859 5.85742 5.85781C10.7645 10.7648 12.5064 12.5069 19.9996 20H39.9996C39.9996 8.95437 31.0452 0 19.9996 0Z"
        fill="#0052B4"
      />
      <path
        d="M13.6947 19.999L11.2522 18.8501L12.5529 16.4845L9.90059 16.992L9.56449 14.3125L7.71699 16.2831L5.86957 14.3125L5.5334 16.992L2.88113 16.4845L4.18184 18.8501L1.73926 19.999L4.18184 21.1479L2.88113 23.5134L5.53363 23.0061L5.86949 25.6855L7.71699 23.7148L9.56449 25.6855L9.90059 23.0061L12.5528 23.5135L11.2521 21.148L13.6947 19.999Z"
        fill="#FFDA44"
      />
      <path
        d="M5.33389 7.82715L6.1467 8.96332L7.47834 8.54152L6.64881 9.66559L7.46162 10.8018L6.13615 10.3603L5.3067 11.4843L5.31709 10.0874L3.9917 9.64582L5.32357 9.22402L5.33389 7.82715Z"
        fill="#FFDA44"
      />
      <path
        d="M5.33389 28.5176L6.1467 29.6537L7.47834 29.2319L6.64881 30.356L7.46162 31.4922L6.13615 31.0507L5.3067 32.1747L5.31709 30.7778L3.9917 30.3362L5.32357 29.9145L5.33389 28.5176Z"
        fill="#FFDA44"
      />
      <path
        d="M16.9272 18.1709L16.1144 19.3071L14.7827 18.8851L15.6122 20.0093L14.7994 21.1455L16.1249 20.7039L16.9544 21.8279L16.944 20.4311L18.2694 19.9896L16.9376 19.5678L16.9272 18.1709Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112152">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PhilippinesSvg;
